export default __webpack_public_path__ + "static/media/ricknmorty.dad13e15.png";